import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GladlyService {
  private gladlyReady?: Promise<any>;

  private ensureLoaded(): Promise<any> {
    if (!this.gladlyReady) {
      this.gladlyReady = this.loadGladly();
    }
    return this.gladlyReady;
  }

  private loadGladly(): Promise<any> {
    return new Promise((resolve, reject) => {
      if ((window as any).Gladly) {
        resolve((window as any).Gladly);
        return;
      }

      // This is the bootstrap IIFE — it creates the window.Gladly stub
      const w = window as any;
      const r = 'Gladly';
      const env = 'PROD';
      let initArgs: any;
      const pending: any[] = [];

      const cdnUrl = env === 'PROD'
        ? 'https://cdn.gladly.com/chat-sdk/widget.js'
        : 'https://cdn.gladly.qa/gladly/chat-sdk/widget.js';

      w[r] = {
        init: function () {
          initArgs = arguments;
          const chain = {
            then: (t: any) => { pending.push({ type: 't', next: t }); return chain; },
            catch: (t: any) => { pending.push({ type: 'c', next: t }); return chain; },
          };
          return chain;
        },
      };

      w.__onHelpAppHostReady__ = function (sdk: any) {
        delete w.__onHelpAppHostReady__;
        w[r] = sdk;
        sdk.loaderCdn = cdnUrl;
        if (initArgs) {
          let chain = sdk.init.apply(sdk, initArgs);
          for (let i = 0; i < pending.length; i++) {
            const p = pending[i];
            chain = p.type === 't' ? chain.then(p.next) : chain.catch(p.next);
          }
        }
        resolve(sdk);
      };

      // Now inject the actual script
      const script = document.createElement('script');
      script.async = true;
      script.src = cdnUrl + '?q=' + new Date().getTime();
      script.onerror = () => reject(new Error('Failed to load Gladly SDK'));
      document.head.appendChild(script);
    });
  }

  async init(): Promise<void> {
    const appId = 'soothe.com-UrbanCLApp1';
    const Gladly = await this.ensureLoaded();
    try {
      await Gladly.init({ appId, autoShowButton: true });
    } catch (error) {
      // ..
    }
  }

  async setUser(user: { name: string; email?: string; phone?: string }): Promise<void> {

    const Gladly = await this.ensureLoaded();

    try {   
      await this.removeUser();
      
      // Set the new user
      Gladly.setUser(user);

    } catch (error) {
      console.error('Failed to set Gladly user:', error);
    }
    
  }

  async show(): Promise<void> {
    const Gladly = await this.ensureLoaded();
    try {
      Gladly.show();
    } catch (error) {
      // ..
    }
  }

  async removeUser(): Promise<void> {
    const Gladly = await this.ensureLoaded();
    try {
      // Remove old user first (if any)
      if (Gladly.getUser()) {
        Gladly.clearUser();
      }
    } catch (error) {
      // ..
    }
  }
}